export default "__VITE_ASSET__jVJZpX1p__"